<template>
    <div style="min-height: 92vh" class="pa-4">
        <div class="d-flex align-center mb-4">
            <h3 class="text-h5 font-weight-bold">Gestión de Eventos</h3>
            <v-spacer></v-spacer>
        </div>

        <v-tabs v-model="tab" background-color="transparent" color="primary">
            <v-tab>Tabla</v-tab>
            <v-tab>Calendario</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" style="background: transparent;">
            <v-tab-item>
                <div class="mt-4">
                    <uv-data-table :config="config" :data="eventos" :pageRows="15" @buttonClick="dtButtonClick"></uv-data-table>
                </div>
            </v-tab-item>
            <v-tab-item>
                <div class="mt-4">
                    <v-toolbar flat color="transparent">
                        <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
                            Hoy
                        </v-btn>
                        <v-btn fab text small color="grey darken-2" @click="prev">
                            <i class="lni lni-chevron-left"></i>
                        </v-btn>
                        <v-btn fab text small color="grey darken-2" @click="next">
                            <i class="lni lni-chevron-right"></i>
                        </v-btn>
                        <v-toolbar-title v-if="$refs.calendar" class="ml-4">
                            {{ $refs.calendar.title }}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-sheet height="600" class="mt-2">
                        <v-calendar
                            ref="calendar"
                            v-model="focus"
                            color="primary"
                            :events="calendarEvents"
                            :event-color="getEventColor"
                            :type="type"
                            @change="updateRange"
                        ></v-calendar>
                    </v-sheet>
                </div>
            </v-tab-item>
        </v-tabs-items>

        <modal v-model="showModal" :showFooter="false" :title="editMode ? 'Editar Evento' : 'Nuevo Evento'">
            <EventosForm :edit="editMode" :key="formKey" :dataEdit="editData" @toggle="showModal = false"
                @successData="successData" />
        </modal>
    </div>
</template>

<script>
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import EventosForm from "./EventosForm.vue";

export default {
    name: "Eventos",
    components: {
        modal,
        uvDataTable,
        EventosForm,
    },
    data() {
        return {
            tab: null,
            focus: '',
            type: 'month',
            calendarEvents: [],
            colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
            calStart: null,
            calEnd: null,
            showModal: false,
            editMode: false,
            editData: {},
            formKey: 0,
            dias: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
            eventos: [],
            config: {
                selectableRow: true,
                orderByCol: { Field: "Nombre", Type: "Asc" },
                allowExport: true,
                rawText: "Eventos",
                selectConfig: {
                    idRowData: "Id",
                },
                buttons: [
                    {
                        text: "Agregar",
                        icon: "lni lni-plus",
                        buttonId: "addEvento",
                    },
                    {
                        text: "Editar",
                        icon: "lni lni-pencil-alt",
                        buttonId: "editEvento",
                        require: true,
                    },
                    {
                        text: "Eliminar",
                        icon: "lni lni-trash",
                        buttonId: "deleteEvento",
                        require: true,
                    },
                ],
                fields: [
                    {
                        text: "Nombre de Evento",
                        value: "nm",
                    },
                    {
                        text: "Tipo de Recurrencia",
                        value: "Tipo",
                        format: (row) => {
                            return row.tr === "F" ? "Fecha Fija" : "Se repite";
                        }
                    },
                    {
                      text: "Detalle Recurrencia",
                      value: "Recurrencia",
                      format: (row) => {
                        if (row.tr === "R" && Array.isArray(row.vr)) {
                          return row.vr
                            .map((v) => this.dias[parseInt(v)] || v)
                            .join(", ");
                        }
                        return row.vr && row.vr[0] ? row.vr[0] : "";
                      },
                    },
                    {
                        text: "Descripción",
                        value: "ds",
                    }
                ],
            },
        };
    },
    methods: {
        async getEventos() {
            const firestore = this.$store.getters.getFirebaseApp.firestore;
            const data = await firestore.queryBuilder("MKT_Eventos", [
                firestore.where(
                    "tn",
                    "==",
                    this.$store.getters.getFirebaseApp.tenant
                ),
                firestore.where(
                    "da",
                    "==",
                    null
                ),
            ]);
            if (data.empty) {
                this.eventos = [];

            } else {
                let doc = data.docs.map((doc) => {
                    return { Id: doc.ref.id, ...doc.data() };
                });
                this.eventos = doc;
            }
            if (this.calStart && this.calEnd) {
                this.generateCalendarEvents(this.calStart, this.calEnd);
            }
        },
        getEventColor(event) {
            return event.color;
        },
        setToday() {
            this.focus = '';
        },
        prev() {
            this.$refs.calendar.prev();
        },
        next() {
            this.$refs.calendar.next();
        },
        updateRange({ start, end }) {
            this.calStart = start.date;
            this.calEnd = end.date;
            this.generateCalendarEvents(start.date, end.date);
        },
        generateCalendarEvents(startDateStr, endDateStr) {
            const events = [];
            const start = new Date(startDateStr + 'T00:00:00');
            const end = new Date(endDateStr + 'T23:59:59');

            this.eventos.forEach((evento, index) => {
                const color = this.colors[index % this.colors.length];
                if (evento.tr === 'F') {
                    const fDateStr = evento.vr && evento.vr[0] ? evento.vr[0] : null;
                    if (fDateStr) {
                        events.push({
                            name: evento.nm,
                            start: fDateStr,
                            end: fDateStr,
                            color: color,
                            details: evento.ds
                        });
                    }
                } else if (evento.tr === 'R' && Array.isArray(evento.vr)) {
                    let current = new Date(start);
                    while (current <= end) {
                        const dayOfWeek = current.getDay();
                        if (evento.vr.includes(dayOfWeek.toString()) || evento.vr.includes(dayOfWeek)) {
                            const dStr = current.toISOString().split('T')[0];
                            events.push({
                                name: evento.nm,
                                start: dStr,
                                end: dStr,
                                color: color,
                                details: evento.ds
                            });
                        }
                        current.setDate(current.getDate() + 1);
                    }
                }
            });
            this.calendarEvents = events;
        },
        dtButtonClick(buttonId, idSelected) {
            if (buttonId === "addEvento") {
                this.editMode = false;
                this.editData = {};
                this.formKey++;
                this.showModal = true;
            } else if (buttonId === "editEvento") {
                // console.log(idSelected)
                this.editMode = true;
                this.editData = this.eventos.find(e => e.Id === idSelected[0]);
                this.formKey++;
                this.showModal = true;
            } else if (buttonId === "deleteEvento") {
                // console.log(idSelected)
                this.deleteEvento(idSelected[0]);
            }
        },
        successData(data, mode) {
            const formData = new FormData();
            formData.append("id", data.id);
            formData.append("nm", data.nm);
            formData.append("ds", data.ds);
            formData.append("tr", data.tr);
            formData.append("at", data.at);
            data.vr.forEach((value) => {
                formData.append('vr[]', value);
            });
            data.ag.forEach((value) => {
                formData.append('ag[]', value);
            });
            formData.append("tenant", this.$store.getters.getFirebaseApp.tenant);
            formData.append("tn", this.$store.getters.getFirebaseApp.tenant);
            if (data.Multimedia) {
                formData.append("Multimedia", data.Multimedia, "Multimedia.jpg");
            }

            if (mode === "CREATE") {
                this.$alert.alertConfirmFormData({
                    action: "crear",
                    obj: "el evento",
                    route: "MKT-Eventos-crearEvento",
                    data: formData,
                    onSuccess: () => {
                        this.getEventos();
                        this.showModal = false;
                    },
                });
            } else {
                this.$alert.alertConfirmFormData({
                    action: "actualizar",
                    obj: "el evento",
                    route: "MKT-Eventos-actualizarEvento",
                    data: formData,
                    onSuccess: () => {
                        this.getEventos()
                        this.showModal = false;
                    },
                });
            }

        },
        deleteEvento(id) {
            const formData = new FormData();
            formData.append("id", id);
            formData.append("Id", id);
            formData.append("tenant", this.$store.getters.getFirebaseApp.tenant);
            this.$alert.alertConfirmFormData({
                action: "eliminar",
                route: "MKT-Eventos-eliminarEvento",
                data: formData,
                obj: "el evento",
                onSuccess: () => {
                    this.getEventos()
                },
            });
        }
    },
    mounted() {
        this.getEventos();
    }
};
</script>

<style scoped>
.text-h5 {
    color: #333;
}
</style>
